import { useDebugValue, useEffect, useState } from 'react';
import ajaxClient from '../../utils/ajaxClient';
import { interceptErrorMessage } from '../helpers/apiErrorsInterceptor';

const useGetCurrentUserSettings = () => {
  useDebugValue('useGetCurrentUser');

  const [isFetching, setIsFetching] = useState(true);
  const [userSettings, setUserSettings] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const fetchCurrentUserData = () => {
    const url = 'Users/Current';

    ajaxClient
      .getRequest(url, null)
      .then((response) => {
        if (response) {
          setUserSettings(response.data);
          setIsFetching(false);
          setErrorMessage(null);
        }
      })
      .catch((exception) => {
        setErrorMessage(interceptErrorMessage(exception));
        setIsFetching(false);
      });
  };

  useEffect(() => {
    fetchCurrentUserData();
  }, []);

  return { isFetching, userSettings, errorMessage };
};

export default useGetCurrentUserSettings;
